import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const InsuranceComponent = () => {
  return (
    <div className="iqama-component">
      <Container fluid>
        <Outlet />
      </Container>
    </div>
  );
};
export default InsuranceComponent;
